module.exports = __webpack_public_path__ + "img/error.240a177f.png";